/* Mensaje de envío de la barra de anuncio. Misma lógica, mismos festivos y mismas frases que la línea de envío de la ficha del box (psb-b06-ficha.js, LINEA-ENVIO ronda 7).
   Hora de Santiago, no la del aparato. Corte 15:00 lun-sáb, 13:00 dom. Sin JS o en un año fuera de la lista queda el texto del HTML.
   Forzar un caso: #t=2026-10-13T16:00. Festivos: feriados.cl, 2026 y 2027. Al terminar 2027 se suman los de 2028 (aquí y en psb-b06-ficha.js). */
(function () {
  var FEST = ['2026-01-01', '2026-04-03', '2026-04-04', '2026-05-01', '2026-05-21', '2026-06-21', '2026-06-29', '2026-07-16', '2026-08-15', '2026-09-18', '2026-09-19', '2026-10-12', '2026-10-31', '2026-11-01', '2026-12-08', '2026-12-25',
    '2027-01-01', '2027-03-26', '2027-03-27', '2027-05-01', '2027-05-21', '2027-06-21', '2027-06-28', '2027-07-16', '2027-08-15', '2027-09-17', '2027-09-18', '2027-09-19', '2027-10-11', '2027-10-31', '2027-11-01', '2027-12-08', '2027-12-25'];
  var T = { hoy: 'Si compras antes de las 15:00 llega hoy en Santiago', hoydom: 'Si compras antes de las 13:00 llega hoy en Santiago', man: 'Si compras ahora llega mañana en Santiago', mandom: 'Si compras ahora llega el domingo en Santiago', festhoy: 'Hoy es festivo: llega mañana en Santiago', visp: 'Mañana es festivo: llega el {dia} en Santiago' };
  var DIAS = ['domingo', 'lunes', 'martes', 'miércoles', 'jueves', 'viernes', 'sábado'];
  var els = Array.prototype.slice.call(document.querySelectorAll('[data-psb-envio]'));
  if (!els.length) return;
  els.forEach(function (e) { e.dataset.sinjs = e.textContent; });
  function calcular() {
    var y, m, d, h;
    var f = /#t=(\d{4})-(\d\d)-(\d\d)T(\d\d):(\d\d)/.exec(location.hash);
    if (f) { y = +f[1]; m = +f[2]; d = +f[3]; h = +f[4]; } else {
      var p = {};
      new Intl.DateTimeFormat('en-CA', { timeZone: 'America/Santiago', year: 'numeric', month: '2-digit', day: '2-digit', hour: '2-digit', minute: '2-digit', hourCycle: 'h23' })
        .formatToParts(new Date()).forEach(function (x) { p[x.type] = x.value; });
      y = +p.year; m = +p.month; d = +p.day; h = +p.hour;
    }
    var dia = function (n) { return new Date(Date.UTC(y, m - 1, d + n)); };
    var iso = function (t) { return t.toISOString().slice(0, 10); };
    var cubre = function (t) { var a = iso(t).slice(0, 4); return FEST.some(function (s) { return s.slice(0, 4) === a; }); };
    var fest = function (t) { return FEST.indexOf(iso(t)) >= 0; };
    var hoy = dia(0);
    var t = null;
    var n = 1;
    if (cubre(hoy)) {
      var corte = hoy.getUTCDay() === 0 ? 13 : 15;
      if (!fest(hoy) && h < corte) t = corte === 13 ? T.hoydom : T.hoy;
      else {
        while (n < 8 && cubre(dia(n)) && fest(dia(n))) n++;
        if (n < 8 && cubre(dia(n))) {
          var N = dia(n);
          if (n === 1) t = fest(hoy) ? T.festhoy : (N.getUTCDay() === 0 ? T.mandom : T.man);
          else t = T.visp.replace('{dia}', DIAS[N.getUTCDay()]);
        }
      }
    }
    return t;
  }
  function pintar() {
    try {
      var t = calcular();
      els.forEach(function (e) { e.textContent = t || e.dataset.sinjs; });
    } catch (e) { /* queda el texto sin JS */ }
  }
  window.psbEnvioBarra = calcular;
  pintar();
  window.addEventListener('hashchange', pintar);
})();
